import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect } from 'react';
import inRegions from '@segment/in-regions';
import { remove, setCookie } from '../scripts/cookies';
/**
 * Curried function to reload page after triggered.
 * @param trigger - A boolean to trigger reload.
 * @returns A function to reload page.
 */

var reload = function reload(trigger) {
  var triggerReload = trigger;
  return function () {
    if (triggerReload) {
      triggerReload = false;
      return window.location.reload();
    }
  };
};

var useTrustArc = function useTrustArc(setupPreferences, domain) {
  var inCA = inRegions(["CA"]);
  var fireReload = reload(false);
  var userPreferences = {};
  var modalOpenedOnce = false;
  /**
   * Set userPreferences data to be used
   * to manage cookies for hardcoded scripts.
   */

  var setConsentByRegion = function setConsentByRegion(options) {
    var data = {};

    if (options) {
      data = _objectSpread({}, options);
    } else {
      data = trustArcData();
    }

    var functionalAllowed = data.isApproved ? [0, 2] : [2];
    var advertisingAllowed = data.isApproved && !inCA() ? [0, 3] : [3];
    var enabled = {
      functional: data.decisions.some(function (pref) {
        return functionalAllowed.includes(pref);
      }),
      advertising: data.decisions.some(function (pref) {
        return advertisingAllowed.includes(pref);
      })
    };
    userPreferences = enabled;
  };
  /**
   * Add user consent decisions to Hardcoded cookies
   * To control any hardcoded script added to the site
   * Add the optIn / optOut implementation on this function
   * Now it is just controlling functional cookies.
   */


  var doFunctionalOptInOutUpdates = function doFunctionalOptInOutUpdates() {
    var untypedWindow = window; // Ensures the optimizely object is defined globally.

    untypedWindow.optimizely = untypedWindow.optimizely || [];
    var _ref = userPreferences,
        functional = _ref.functional;
    if (typeof functional === "undefined") return; // Control Otimizely Preferences

    if (functional) remove("optimizelyOptOut");
    untypedWindow.optimizely.push({
      type: "optOut",
      isOptOut: !functional
    }); // Control Mutiny Preferences

    if (untypedWindow.mutiny.client) {
      if (functional) {
        remove("mutiny.optOut");
        untypedWindow.mutiny.client.optIn();
      } else {
        remove("mutiny.optIn");
        untypedWindow.mutiny.client.optOut();
      }
    } // Remove Drift script if functional preference is not set to true.


    if (untypedWindow.drift && !functional) {
      setCookie("driftt_opt_out", "true");
    } else {
      remove("driftt_opt_out");
    }
  };
  /**
   * Register listener for consent changes
   * some care has been taken here to handle messages safely
   * will reload window after submit preferences.
   */


  var managePostMessages = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setConsentByRegion();
              data = event.data;

              if (typeof data === "string") {
                try {
                  data = JSON.parse(data);
                } catch (_err) {}
              }

              if (data && data.message) {
                // Message send by TrustArc when popup is opened.
                if (data.message === "get_tracker_list") {
                  // User opened the modal at least once.
                  modalOpenedOnce = true;
                } // Message send by TrustArc when user submit preferences
                // from modal or directly from the button on the banner.


                if (data.message === "submit_preferences") {
                  // Check if modal opened before.
                  if (modalOpenedOnce) {
                    fireReload = reload(true);
                  } else {
                    doFunctionalOptInOutUpdates();
                    reload(true)();
                  }
                } // Message send by TrustArc when popup is closed.


                if (data.message === "remove_iframe" && fireReload) {
                  doFunctionalOptInOutUpdates();
                  fireReload();
                }
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function managePostMessages(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Return user consent data from TrustArc's API.
   */


  var trustArcData = function trustArcData() {
    var wt = window;
    var decisions = [0];
    var isApproved = true;

    if (wt.truste && wt.truste.cma) {
      // Call trustArc APIs to get user consent decisions.
      var _wt$truste$cma$callAp = wt.truste.cma.callApi("getGDPRConsentDecision", domain),
          consentDecision = _wt$truste$cma$callAp.consentDecision;

      var _wt$truste$cma$callAp2 = wt.truste.cma.callApi("getConsent", domain),
          _consent = _wt$truste$cma$callAp2.consent;

      decisions = consentDecision;
      isApproved = Boolean(_consent === null || _consent === void 0 ? void 0 : _consent.includes("approved"));
    }

    return {
      decisions: decisions,
      isApproved: isApproved
    };
  }; // Set all preferences to segment after window is fully loaded.


  var setAllPreferences = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _trustArcData, decisions, isApproved;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _trustArcData = trustArcData(), decisions = _trustArcData.decisions, isApproved = _trustArcData.isApproved; // Set preferences from TrustArc to Segment destinations.

              _context2.next = 3;
              return setupPreferences(decisions);

            case 3:
              // Update state to be used as context for all pages.
              setConsentByRegion({
                decisions: decisions,
                isApproved: isApproved
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function setAllPreferences() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var _window$top;

    setAllPreferences(); // Instructs TrustArc to notify on changes to consent.

    (_window$top = window.top) === null || _window$top === void 0 ? void 0 : _window$top.postMessage(JSON.stringify({
      PrivacyManagerAPI: {
        action: "getConsent",
        timestamp: new Date().getTime(),
        self: domain
      }
    }), "*");
    window.addEventListener("message", managePostMessages, false);
    return function () {
      window.removeEventListener("message", managePostMessages);
    };
  }, [domain]);
};

export default useTrustArc;